import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {ChangesRoutePayload, FilesRoutePayload} from './route-payload-types'

export function buildPullRequestsChangesRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsChangesRoute', {
    path: '/:owner/:repo/pull/:pr_number/changes',
    queries: [mainQuery<ChangesRoutePayload>()],
  })
}

export const pullRequestsChangesRoute = buildPullRequestsChangesRoute(pullRequestsAppBuilder)

export function buildPullRequestsChangesWithRangeRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsChangesWithRangeRoute', {
    path: '/:owner/:repo/pull/:pr_number/changes/:range',
    queries: [mainQuery<ChangesRoutePayload>()],
  })
}

export const pullRequestsChangesWithRangeRoute = buildPullRequestsChangesWithRangeRoute(pullRequestsAppBuilder)

export function buildPullRequestsFilesRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsFilesRoute', {
    path: '/:owner/:repo/pull/:pr_number/files',
    queries: [mainQuery<FilesRoutePayload>()],
  })
}

export const pullRequestsFilesRoute = buildPullRequestsFilesRoute(pullRequestsAppBuilder)

export function buildPullRequestsFilesWithRangeRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsFilesWithRangeRoute', {
    path: '/:owner/:repo/pull/:pr_number/files/:range',
    queries: [mainQuery<FilesRoutePayload>()],
  })
}

export const pullRequestsFilesWithRangeRoute = buildPullRequestsFilesWithRangeRoute(pullRequestsAppBuilder)
